import { Dayjs } from "dayjs"

export type OrderType = {
    requestTask: string
    object?: ObjectType
    objectFromCustomer: string
    descriptionTask?: string
    descriptionTaskFromCustomer: string
    descriptionOrder?: string
    priceForRelease?: Number
    priceForReleaseFromCustomer: Number
    contactPerson?: string
    contactTel?: string
    dueDate: Dayjs
    createdAt?: Dayjs
    state?: "created" | "waiting-for-customer-approval" | "assigned" | "unassigned" | "completed" | "declined" | "billed"
    history?: HistoryItem[]
}

export type ObjectType = {
    _id: string
    adress: {
        street: string
        nr: string
        plz: string
        city: string
    }
}

export const OrderRequestActionCode = {
    CREATE: {
        value: "create",
        translation: "Sie haben den Auftrag erstellt.",
    },
    SET_AS_TASK: {
        value: "set-as-task",
        translation: "Der Auftrag wurde angenommen und eingeplant.",
    },
    MARK_AS_WAITING_FOR_CUSTOMER_APPROVAL: {
        value: "mark-as-waiting-for-customer-approval",
        translation: "Der Auftrag wartet auf Zuarbeit bzw. Rückmeldung von Ihnen.",
    },
    DECLINED: {
        value: "declined",
        translation: "Der Auftrag wurde abgelehnt",
    },
    COMPLETE: {
        value: "complete",
        translation: "Der Auftrag wurde abgeschlossen.",
    },
    BILL: {
        value: "billed",
        translation: "Ihnen wurde eine Rechnung für den Auftrag zugestellt.",
    },
    ACCEPTED: {
        value: "accepted",
        translation: "Der Auftrag wurde angenommen.",
    },
} as const

export type HistoryItem = {
    actionCode: (typeof OrderRequestActionCode)[keyof typeof OrderRequestActionCode]["value"]
    message?: string
    timestamp: Date | Dayjs | string
}
